<template>
<div :class="`level-${currentHeight % 8}`">
  <b-row v-if="currentHeight != 0 && item" class="mr-0 pl-1">
    <b-col cols=2>
      <strong>{{item.product_id == null ? item.part_num : item.product_num}}</strong>
      <em>({{(item.children != undefined && item.children.length > 0 ? item.part_id == null ? 'KIT' : 'BOM' : 'INDV')}})</em>
    </b-col>
    <b-col>
      {{item.description}}
    </b-col>
    <b-col cols=2>
      <b-row>
        <b-col>
          {{parseFloat((item.qty / qty).toFixed(2))}} 
          | 
          <strong> Needs {{parseFloat(item.qty.toFixed(2))}} {{item.uomname}}</strong>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols=2>
          <em style="text-align: right;" v-if="!!item.po_num">
            {{parseFloat((item.po_qty).toFixed(2))}} ({{item.po_num}})
          </em>
        </b-col>
    <b-col class="text-right my-1 pr-1" cols=1>
      <b-btn size=sm @click="() => { this.showChildren = !this.showChildren }" v-if="item.children != null && item.children.length > 0" >
        <div v-if=this.showChildren>
          <i class="fas fa-angle-double-up" />
        </div>
        <div v-else>
          <i class="fas fa-angle-double-down" />
        </div>
      </b-btn>
    </b-col>
  </b-row>

  <b-list-group flush v-if="showChildren" >
    <b-list-group-item v-for="it in item.children" :key="`${it.part_id}|${it.product_id}`" class="py-1 pr-0">
      <bom-kit-cookbook-item :item="it" :currentHeight="currentHeight+1" :qty=qty />
    </b-list-group-item>
  </b-list-group>
</div>
</template>

<script>
const BASE_API = process.env.VUE_API_ROOT;

export default ({
  name: 'bom-kit-cookbook-item',
  data() {
    return {
      showChildren: true
    };
  },
  props: {
    currentHeight: { type: Number, default: 0 },
    item: { type: Object, default: null},
    qty: { type: Number, default: 1 }
  },
  mounted() {
    if (this.currentHeight > 1) this.showChildren = false;
  },
  methods: {

  },
})
</script>

<style scoped>
.level-1 {
  background-color: rgba(255,0,0,.3)
}
.level-2 {
  background-color: rgba(255,165,0,.3)
}
.level-3 {
  background-color: rgba(255,255,0,.3)
}
.level-4 {
  background-color: rgba(0,128,0,.3)
}
.level-5 {
  background-color: rgba(0,0,255,.3)
}
.level-6 {
  background-color: rgba(75,0,130,.3)
}
.level-7 {
  background-color: rgba(238,130,238,.3)
}
</style>


// WEBPACK FOOTER //
// src/components/purchasing/BomKitCookbookItem.vue